<template>
<div class="LotteryRollList">
    <div class="search_handle_box">
        <div class="left_box">
            <el-button @click="downExcel">导出EXCEL</el-button>
        </div>
        <div class="right_box">
            <div class="sign_time_box">
                <el-date-picker @focus="closeDetalisInfo" v-model="searchParams.times" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"></el-date-picker>
            </div>
            <div style="width: 150px;">
                <el-input @focus="closeDetalisInfo" v-model="searchParams.signName" placeholder="参与人"></el-input>
            </div>
            <el-button @click="handleQuery" type="primary" plain>搜索</el-button>
        </div>
    </div>
    <div class="table_box">
        <el-table  :data="tableData" style="width: 100%">
            <el-table-column prop="index" label="序号" align="center" width="120"></el-table-column>
            <el-table-column label="参与人" align="center" min-width="200">
                <template slot-scope="scope">
                    <div class="user_info_box">
                        <img :src="scope.row.logourl" alt="">
                        <span>{{scope.row.customername}}</span>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="datetime" label="参与时间" align="center" min-width="180"></el-table-column>
            <el-table-column prop="status" label="参与状态" align="center" min-width="50"></el-table-column>
            <el-table-column prop="isdraw" label="是否抽奖" align="center"></el-table-column>
            <el-table-column prop="drawtime" label="抽奖时间" align="center" min-width="180"></el-table-column>
            <el-table-column prop="isaward" label="是否中奖" align="center"></el-table-column>
            <el-table-column prop="awardlevelname" label="奖项名称" align="center"></el-table-column>
            <el-table-column label="操作" align="right">
                <template slot-scope="scope">
                    <span style="color: #439FFE;" @click="tableRowClick(scope.row)" v-if="scope.row">详情</span>
                    <span style="color: #439FFE;" v-if="scope.row.isshowsend">  |  </span>
                    <span style="color: #439FFE;" v-if="scope.row.isshowsend" @click="editDistributionMsg(scope.row)">发货信息</span>
                </template>
            </el-table-column>
        </el-table>
        <page :total="total" ref="page" @getList="searchBtn"></page>
    </div>
    <div class="right_details_box bgc box-shadow" :class="showRollDetail ? 'show_helps_box' : 'hide_icon_box'" ref="helps">
        <div v-if="showRollDetail" class="show_helps show_icon" @click="showRollDetail = false"></div>
        <div class="title_box">
            <span>详情资料</span>
            <img @click="showRollDetail = false" :src="require('@/common/images/activeOperate/close_icon.png')" alt="">
        </div>
        <div class="details_info_box">
            <div class="box1">
                <img :src="listDetailsInfo.logourl === '' ? require('@/common/images/other/user.png') : listDetailsInfo.logourl" alt="">
                <div>
                    <p>{{listDetailsInfo.customername}}</p>
                    <p>参与时间：{{listDetailsInfo.datetime}}</p>
                    <p>是否抽奖：{{listDetailsInfo.isdraw}}</p>
                    <p v-if="listDetailsInfo.isdraw === '是'">抽奖时间：{{listDetailsInfo.drawtime}}</p>
                </div>
            </div>
            <div class="box2">
                <p>详细信息</p>
                <p v-for="(item, index) in listDetailsInfo.objlist" :key="index"><span>{{item.colname}}</span><span>{{item.colvalue}}</span></p>
                <div v-if="listDetailsInfo.objlist.length === 0" class="no_info_box">
                    <img :src="require('@/common/images/other/noinfo.png')" alt="">
                    <span>当前暂无详细信息</span>
                </div>
            </div>
            <div class="box2 distributionMsg" v-if="row.isshipinfo">
                <p>配送信息</p>
                <div class="item">
                    <div class="left">收货人</div>
                    <div class="right">{{row.shipname}}</div>
                </div>
                <div class="item">
                    <div class="left">收货地址</div>
                    <div class="right address">{{row.shipaddress}}</div>
                </div>
                <div class="item">
                    <div class="left">收货电话</div>
                    <div class="right">{{row.shiptel}}</div>
                </div>
                <div class="item">
                    <div class="left">配送状态</div>
                    <div class="right">{{row.shipname}}</div>
                </div>
                <div class="item">
                    <div class="left">配送公司名称</div>
                    <div class="right radio-group">
                        <el-radio-group v-model="row.shipstatus" disabled>
                            <el-radio :label=0>未配送</el-radio></br>
                            <el-radio :label=1>配送中</el-radio></br>
                            <el-radio :label=10>配送完成</el-radio>
                        </el-radio-group>
                    </div>
                </div>
                <div class="item">
                    <div class="left">配送订单号</div>
                    <div class="right">{{row.shipno}}</div>
                </div>
                <div class="item">
                    <div class="left">配送时间</div>
                    <div class="right">{{row.shiptime}}</div>
                </div>
            </div>
        </div>
    </div>
    <el-dialog title="发货信息" :visible.sync="dialogFormVisible">
        <el-form :model="form">
            <el-form-item label="快递公司名称" :label-width="formLabelWidth">
                <el-input v-model="form.shipcompany" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="快递单号" :label-width="formLabelWidth">
                <el-input v-model="form.shipno" autocomplete="off"></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible = false">取 消</el-button>
            <el-button type="primary" @click="submit">确 定</el-button>
        </div>
    </el-dialog>
</div>
</template>

<script>
import {exportLuckdrawRollExcel, getLuckdrawEventRollList, getLuckdrawEventRollDetail, updateLuckEventship} from 'api/operateToolApi'
import Page from 'base/page/page'
import {mapGetters, mapActions} from 'vuex'
import {dateFormat} from 'common/js/tools'
export default {
    name: 'LotteryRollList',
    data() {
        return {
            total: 0,
            searchParams: {
                signName: '',
                times: ''
            },
            tableData: [],
            showRollDetail: false, // 右侧名单详情显示隐藏
            oldInnerid: '',
            newInnerid: '',
            listDetailsInfo: {
                customername: '',
                datetime: '',
                interacttime: '',
                isinteract: '',
                isinteracttext: '',
                joinermobile: '',
                joinername: '',
                logourl: '',
                objlist: []
            },
            row: '',
            dialogFormVisible: false,
            formLabelWidth: '120px',
            form: {
                shipcompany: '',
                shipno: ''
            }
        }
    },
    mounted() {
        this.searchBtn()
    },
    methods: {
        // 导出互动名单列表 Excel
        downExcel() {
            this.closeDetalisInfo()
            this.setLoading(true)
            var params = {
                eventinnerid: this.$route.query.eventinnerid,
                customername: this.searchParams.signName,
                begintime: '',
                endtime: ''
            }
            if (this.searchParams.times !== '') {
                params.begintime = this.searchParams.times[0]
                params.endtime = this.searchParams.times[1]
            }
            exportLuckdrawRollExcel({
                data: params,
                success: data => {
                    this.setLoading(false)
                    let blob = new Blob([data], {type: 'application/vnd.ms-excel'})
                    let fileName = '互动名单列表' + dateFormat(new Date()) + '.xls'
                    if (window.navigator.msSaveOrOpenBlob) {
                        navigator.msSaveBlob(blob, fileName)
                    } else {
                        var link = document.createElement('a')
                        link.href = window.URL.createObjectURL(blob)
                        link.download = fileName
                        link.click() // 释放内存
                        window.URL.revokeObjectURL(link.href)
                    }
                    this.$message.success('导出成功')
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        // 关闭右侧名单详情
        closeDetalisInfo() {
            this.showRollDetail = false
        },
        // 名单表格每一行点击查询名单详情
        tableRowClick(row, event, column) {
            this.row = row
            // this.row.shipname = '袁桢'
            // this.row.shipaddress = '四川省成都市金牛区凤凰山街道绿地世纪城14栋二单元803'
            // this.row.shiptel = '13438751611'
            // this.row.shipstatus = 0
            // this.row.shipcompanyname = '韵达'
            // this.row.shipno = '123456789987'
            this.oldInnerid = this.newInnerid
            this.newInnerid = row.innerid
            if (this.oldInnerid === this.newInnerid) {
                this.showRollDetail = !this.showRollDetail
            } else {
                this.showRollDetail = false
                this.findInteractEventRollDetail(row)
            }
        },
        // 获取名单详情
        findInteractEventRollDetail(val) {
            this.setLoading(true)
            var params = {
                innerid: val.innerid
            }
            getLuckdrawEventRollDetail({
                data: Object.assign({}, params),
                success: data => {
                    this.setLoading(false)
                    this.listDetailsInfo = data.data
                    this.showRollDetail = true
                    // setTimeout(() => {
                    //     this.showRollDetail = true
                    // },50 )
                },
                error: data => {
                    console.log('error：', data)
                    this.$message.error(data.msg)
                    this.setLoading(false)
                }
            })
        },
        // 分页及搜索
        handleQuery() {
            this.total = 0
            this.$refs.page.handleSizeChange(1)
        },
        // 搜索按钮
        searchBtn() {
            this.setLoading(true)
            if (this.searchParams.times === null) {
                this.searchParams.times = ''
            }
            var params = {
                eventinnerid: this.$route.query.eventinnerid,
                customername: this.searchParams.signName,
                begintime: '',
                endtime: ''
            }
            if (this.searchParams.times !== '') {
                params.begintime = this.searchParams.times[0]
                params.endtime = this.searchParams.times[1]
            }
            getLuckdrawEventRollList({
                data: Object.assign({}, params, this.page),
                success: data => {
                    this.setLoading(false)
                    this.tableData = data.data.content
                    this.total = data.data.pageinfo.rowCount
                    // setTimeout(() => {
                    // },50 )
                    this.closeDetalisInfo()
                },
                error: data => {
                    console.log('error：', data)
                    this.$message.error(data.msg)
                    this.setLoading(false)
                }
            })
        },
        // 填写收货信息
        editDistributionMsg(row) {
            this.row = row
            this.dialogFormVisible = true
        },
        // 提交发货信息
        submit() {
            let that = this
            if (this.form.shipcompany && this.form.shipno) {
                console.log(this.row)
                this.setLoading(true)
                updateLuckEventship({
                    data: Object.assign({}, that.form, {innerid: this.row.innerid}, {eventinnerid: this.$route.query.eventinnerid}),
                    success: data => {
                        this.row.isshipinfo = 1
                        this.row.isshowsend = 0
                        this.dialogFormVisible = false
                        this.setLoading(false)
                    },
                    error: data => {
                        this.setLoading(false)
                        this.$message.error(data.msg)
                    }
                })
            } else {
                if (!this.form.shipcompany) {
                    this.$message.error('请填写快递公司名称')
                } else if (!this.form.shipno) {
                    this.$message.error('请填写快递单号')
                }
            }
        },
        ...mapActions([
            'setLoading'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([
            'page'
        ])
    },
    components: {
        Page
    }
}
</script>

<style lang="scss" type="text/scss">
.LotteryRollList {
    font-family:PingFangSC-Regular,PingFang SC;
    .search_handle_box {
        display: flex;
        justify-content: space-between;
        .right_box {
            display: flex;
            .el-input__icon {
                line-height: 0px;
            }
            &>div {
                margin-right: 30px;
            }
            .sign_time_box {
                .el-date-editor .el-range-separator {
                    line-height: 24px;
                }
                .el-date-editor--daterange.el-input__inner {
                    width: 260px;
                }
            }
        }
    }
    .table_box {
        margin-top: 30px;
        .el-table th>.cell {
            font-weight: bold!important;
        }
        .el-table__empty-block {
            min-height: 360px;
        }
        .el-table__empty-text {
            box-sizing: border-box;
            line-height: 0px;
            padding-top: 150px;
        }
        .el-table__row {
            cursor: pointer;
        }
        .user_info_box {
            display: flex;
            align-items: center;
            justify-content: center;
            img{
                width: 50px;
                height: 50px;
                border-radius: 50%;
                margin-right: 10px;
            }
            span{
                color: #409EFF;
            }
        }
    }
    .right_details_box{
        position: fixed;
        top: 50px;
        right: -398px;
        height: 95.5vh;
        width: 398px;
        z-index: 10;
        box-sizing: border-box;
        box-shadow:-2px 0px 6px 0px rgba(0,0,0,0.1);
        font-family:PingFangSC-Regular,PingFang SC;
        .show_helps{
            width: 12px;
            height: 50px;
            background-size:12px 50px !important;
            position: absolute;
            top: 46%;
            left: -12px;
            cursor: pointer;
            border-radius: 6px 0 0 6px;
        }
        .show_helps:hover{
            background-color: #ccc;
        }
        .show_icon{
            background-image: url('../../../common/images/other/show.png');
        }
        .title_box{
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 0 20px;
            height: 52px;
            box-shadow: -2px 0px 6px 0px rgba(0,0,0,0.1);
            span{
                font-weight: bold;
                font-size: 15px;
            }
            img {
                width: 10px;
                height: 10px;
                cursor: pointer;
            }
        }
        .details_info_box {
            .box1 {
                display: flex;
                align-items: center;
                padding: 30px 20px 40px 20px;
                img {
                    width: 64px;
                    height: 64px;
                    border-radius: 100%;
                    margin-right: 28px;
                }
                div {
                    p{
                        color:#999999;
                        line-height:20px;
                    }
                    p:nth-of-type(1){
                        color: #333333;
                    }
                    p:nth-of-type(2){
                        margin-top: 8px;
                        margin-bottom: 8px;
                    }
                    p:nth-of-type(3){
                        margin-bottom: 8px;
                    }
                }
            }
            .box2 {
                padding: 0 20px;
                p{
                    display: flex;
                    line-height:20px;
                    color: #333333;
                    margin-top: 20px;
                    span:nth-of-type(1){
                        line-height:20px;
                        color:#999999;
                        width: 120px;
                        min-width: 120px;
                        white-space: nowrap;
                    }
                    span:nth-of-type(2){
                        line-height:20px;
                    }
                }
                p:nth-of-type(1){
                    margin-top: 0px;
                    border-bottom: solid 1px #E5E5E5;
                    padding: 8px 0;
                    font-weight: bold;
                    font-size: 15px;
                }
                .no_info_box {
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    padding: 30px 0;
                    span {
                        margin-top: 10px;
                        color:#999999;
                    }
                }
            }
            .distributionMsg {
                .item {
                    display: flex;
                    line-height: 40px;
                    .left {
                        min-width: 90px;
                    }
                    .address {
                        line-height: 25px;
                        padding-top: 7px;
                    }
                    .radio-group {
                        padding-top: 14px;
                        line-height: 13px;
                        .el-radio {
                            margin-bottom: 10px;
                        }
                    }
                }
            }
        }
    }
    .show_helps_box{
        right: 0;
        transition: 0.5s all;
    }
    .hide_icon_box{
        right: -398px;
        transition: 0.5s all;
    }
}
</style>
